﻿/**
 * Aria.ts
 *
 * Module for wrapper around Aria
 */

let aria: any = require("./../../thirdparty/aria-webjs-compact-sdk-1.2.0");

export function AWT() { return aria.AWT; };
